module.exports = __webpack_public_path__ + "img/business-profile.aafbd6b8.png";